import type { ConfirmDialogBodyProps } from "./types";

export function ConfirmDialogBody({ children }: ConfirmDialogBodyProps) {
  return (
    <div className="px-6 py-4 text-[14px] text-secondary leading-relaxed overflow-y-auto min-h-0 flex-1">
      {children}
    </div>
  );
}
